<div class="space-y-3.5">
  <!-- 1. Récapitulatif quotidien 8h00 -->
  <div
    class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs flex items-center justify-between gap-3"
  >
    <div class="flex items-center gap-3 min-w-0">
      <div
        class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
        [class.bg-primary-2]="resolved().emailAlertsEnabled"
        [class.text-primary-11]="resolved().emailAlertsEnabled"
        [class.bg-neutral-2]="!resolved().emailAlertsEnabled"
        [class.dark:bg-neutral-3]="!resolved().emailAlertsEnabled"
        [class.text-neutral-10]="!resolved().emailAlertsEnabled"
      >
        <mat-icon class="!w-4.5 !h-4.5 !text-lg">mail</mat-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-xs text-neutral-10 font-medium">Récapitulatif mandats par email</span>
        <span class="text-sm font-bold text-neutral-12">
          {{ resolved().emailAlertsEnabled ? 'Chaque matin à 8h00' : 'Alertes désactivées' }}
        </span>
      </div>
    </div>
    <span
      class="text-[10px] font-bold px-2 py-0.5 rounded-full border shrink-0"
      [class.bg-primary-2]="resolved().emailAlertsEnabled"
      [class.text-primary-11]="resolved().emailAlertsEnabled"
      [class.border-primary-4]="resolved().emailAlertsEnabled"
      [class.bg-neutral-2]="!resolved().emailAlertsEnabled"
      [class.dark:bg-neutral-3]="!resolved().emailAlertsEnabled"
      [class.text-neutral-10]="!resolved().emailAlertsEnabled"
      [class.border-neutral-3]="!resolved().emailAlertsEnabled"
      [class.dark:border-neutral-4]="!resolved().emailAlertsEnabled"
    >
      {{ resolved().emailAlertsEnabled ? 'Actif' : 'Désactivé' }}
    </span>
  </div>

  <!-- 2. Filtres de pertinence mandats (uniquement si alertes activées) -->
  @if (resolved().emailAlertsEnabled) {
    <div
      class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-3"
    >
      <div class="flex items-center gap-2 text-xs font-bold text-neutral-11 uppercase tracking-wider">
        <mat-icon class="!w-4 !h-4 !text-base text-primary-9">filter_list</mat-icon>
        <span>Critères de réception des opportunités</span>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1">
        <!-- Types de mandats -->
        <div
          class="flex flex-col gap-1.5 p-3 rounded-xl bg-neutral-1 dark:bg-neutral-3/40 border border-neutral-2 dark:border-neutral-4"
        >
          <span class="text-[11px] font-semibold text-neutral-10 uppercase tracking-wide"
            >Types de mandats</span
          >
          <div class="flex flex-wrap gap-1.5">
            @for (label of resolved().mandateLabels; track label) {
              <span
                class="text-xs font-semibold px-2 py-0.5 rounded-lg bg-white dark:bg-neutral-2 border border-neutral-3 dark:border-neutral-4 text-neutral-12 shadow-2xs"
              >
                {{ label }}
              </span>
            }
          </div>
        </div>

        <!-- Fourchette de prix -->
        <div
          class="flex flex-col gap-1.5 p-3 rounded-xl bg-neutral-1 dark:bg-neutral-3/40 border border-neutral-2 dark:border-neutral-4"
        >
          <span class="text-[11px] font-semibold text-neutral-10 uppercase tracking-wide"
            >Fourchette de prix des biens</span
          >
          <span class="text-xs font-bold text-neutral-12">
            {{ resolved().priceRangeText }}
          </span>
        </div>
      </div>
    </div>
  }

  <!-- 3. Alerte solde de crédits bas -->
  <div
    class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs flex items-center justify-between gap-3"
  >
    <div class="flex items-center gap-3 min-w-0">
      <div
        class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
        [class.bg-amber-2]="resolved().creditLowAlertEnabled"
        [class.text-amber-11]="resolved().creditLowAlertEnabled"
        [class.bg-neutral-2]="!resolved().creditLowAlertEnabled"
        [class.dark:bg-neutral-3]="!resolved().creditLowAlertEnabled"
        [class.text-neutral-10]="!resolved().creditLowAlertEnabled"
      >
        <mat-icon class="!w-4.5 !h-4.5 !text-lg">token</mat-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-xs text-neutral-10 font-medium">Alerte de solde de crédits</span>
        <span class="text-sm font-bold text-neutral-12">
          @if (resolved().creditLowAlertEnabled) {
            Alerte par email si solde &le; {{ resolved().creditThreshold }} crédits
          } @else {
            Désactivée
          }
        </span>
      </div>
    </div>
    <span
      class="text-[10px] font-bold px-2 py-0.5 rounded-full border shrink-0"
      [class.bg-amber-2]="resolved().creditLowAlertEnabled"
      [class.text-amber-11]="resolved().creditLowAlertEnabled"
      [class.border-amber-4]="resolved().creditLowAlertEnabled"
      [class.bg-neutral-2]="!resolved().creditLowAlertEnabled"
      [class.dark:bg-neutral-3]="!resolved().creditLowAlertEnabled"
      [class.text-neutral-10]="!resolved().creditLowAlertEnabled"
      [class.border-neutral-3]="!resolved().creditLowAlertEnabled"
      [class.dark:border-neutral-4]="!resolved().creditLowAlertEnabled"
    >
      {{ resolved().creditLowAlertEnabled ? 'Actif' : 'Désactivé' }}
    </span>
  </div>
</div>
